<template>
  <div class="container-fluid">
    <div class="contents booking">
      <search />
      <b-form class="row row-cols-1 row-cols-sm-2 row-cols-md-auto g-2 mb-4">
        <div class="col">
          <select
            class=""
            aria-label="search select"
            v-model="searchData.searchroomno"
          >
            <option value="0">{{ $t("filter.common.total") }}</option>
            <template v-for="(rno, index) in searchroomlist">
              <option :value="rno.roomnum" :key="index + 'r'">
                {{ rno.roomname }}
              </option>
            </template>
          </select>
        </div>
        <div class="col">
          <div class="input-group">
            <input
              type="date"
              class="form-control"
              name="searchdate"
              v-model="searchData.searchdate"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="button"
              @click="searchDateChange"
            ></button>
          </div>
        </div>
      </b-form>

      <table class="table board">
        <thead>
          <tr>
            <th class="col-auto">{{ $t("title.booking.room_name") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto">{{ $t("title.common.time") }}</th>
            <th class="col-auto d-none d-lg-table-cell">
              {{ $t("title.common.memo") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.status") }}
            </th>
            <th class="th-arrow">&nbsp;</th>
          </tr>
        </thead>
        <tbody v-if="bookinglist.length">
          <template v-for="(item, idx) in bookinglist">
            <tr :key="idx">
              <td class="col-auto">{{ item.aliasname }}</td>
              <td class="col-auto d-none d-lg-table-cell text-date">
                {{ item.timezone_starttime | dateformat("YYYY.MM.DD") }}
              </td>
              <td class="col-auto w-1">
                {{ item.timezone_starttime | dateformat("HH:00") }} ~
                {{ $dayjs(item.timezone_endtime).format("HH:59") }}
              </td>
              <td
                class="col-auto d-none d-lg-table-cell"
                v-if="item.memo != null && item.memo.length > 22"
              >
                {{ item.memo.substr(0, 20) }}..
              </td>
              <td class="col-auto d-none d-lg-table-cell" v-else>
                {{ item.memo }}
              </td>
              <td class="d-none d-sm-table-cell">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-xs"
                  @click="modalOpen(item)"
                >
                  {{ $t("button.common.view") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(idx)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === idx }"
                />
              </td>
            </tr>

            <tr
              class="d-lg-none"
              :class="{ show: view_hide === idx }"
              :key="idx + 'r'"
              v-if="view_hide === idx"
            >
              <td colspan="6">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.date") }}
                    </div>
                    <div class="col-8 text-date">
                      {{ item.timezone_starttime | dateformat("YYYY.MM.DD") }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.memo") }}</div>
                    <div
                      class="col-8"
                      v-if="item.memo != null && item.memo.length > 16"
                    >
                      {{ item.memo.substr(0, 14) }}..
                    </div>
                    <div class="col-8" v-else>
                      {{ item.memo }}
                    </div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.booking.status") }}</div>
                    <div class="col-8">
                      <button
                        type="button"
                        class="btn btn-outline-secondary btn-xs"
                        @click="modalOpen(item)"
                      >
                        {{ $t("button.common.view") }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="6" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.booking.booking_write')"
          @click="bookingRev"
          >{{ $t("button.booking.booking_write") }}</b-button
        >
      </div>
    </div>

    <b-modal
      id="modal-booking-list"
      ref="modal-booking-list"
      size="lg"
      centered
      scrollable
      footer-class="btn-bottom-wrapper"
    >
      <template #modal-header="{ close }">
        <h5 class="modal-title">
          {{ $t("title.setting.booking") }}
        </h5>
        <b-button
          variant="close"
          :aria-label="$t('button.common.close')"
          @click="close()"
        ></b-button>
      </template>

      <div class="row g-0 table-type header-col p-keep">
        <div class="col-sm-4">
          {{ $t("title.booking.room_name") }}
        </div>
        <div class="col-sm-8">
          <select class="" v-model="modalObj.roomno">
            <template v-for="(rno, index) in roomlist">
              <option :value="rno.roomnum" :key="index + 'r'">
                {{ rno.roomname }}
              </option>
            </template>
          </select>
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.date") }}
        </div>
        <div class="col-sm-8">
          <div class="row row-cols-2 row-cols-lg-3 g-2">
            <div class="col-12">
              <input
                type="date"
                class="form-control-lg"
                v-model="bookingDate"
              />
            </div>
            <div class="col-6">
              <select class="w-100" v-model="bookingStime">
                <option v-for="(time, idx) in starttimes" :key="idx">
                  {{ time }}
                </option>
              </select>
            </div>
            <div class="col-6">
              <select class="w-100" v-model="bookingEtime">
                <option v-for="(time, idx) in endtimes" :key="idx">
                  {{ time }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-4">
          {{ $t("title.common.memo") }}
        </div>
        <div class="col-sm-8">
          <textarea v-model="modalObj.memo" cols="30" rows="10"></textarea>
        </div>
      </div>

      <template #modal-footer="{ cancel }">
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="cancel"
          @click="cancel()"
          >{{ $t("button.common.cancel") }}</b-button
        >
        <b-button
          size="md"
          variant="outline-secondary"
          aria-label="delete"
          @click="bookinDelete"
          >{{ $t("button.common.delete") }}</b-button
        >
        <b-button
          size="md"
          variant="secondary"
          aria-label="save"
          @click="bookinSave"
          >{{ $t("button.common.save") }}</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import Search from "./Search";
import commonDatePicker from "@/components/common/datepicker/Picker";
import { utils } from "@/mixin/utils";
import "@/filter/common";
import ax from "@/api/booking";
import _ from "lodash";

export default {
  name: "BookingTable",
  components: {
    Search,
  },
  mixins: [utils],
  data() {
    return {
      searchData: {
        searchdate:
          this.$route.query.searchdate ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchdate) ||
          this.$dayjs(new Date()).format("YYYY-MM-DD"),
        searchroomno:
          this.$route.query.searchroomno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchroomno) ||
          "0",
      },
      bookinglist: [],
      data_yn: true,
      starttimes: [
        "05:00",
        "06:00",
        "07:00",
        "08:00",
        "09:00",
        "10:00",
        "11:00",
        "12:00",
        "13:00",
        "14:00",
        "15:00",
        "16:00",
        "17:00",
        "18:00",
        "19:00",
        "20:00",
        "21:00",
        "22:00",
        "23:00",
      ],
      endtimes: [
        "05:59",
        "06:59",
        "07:59",
        "08:59",
        "09:59",
        "10:59",
        "11:59",
        "12:59",
        "13:59",
        "14:59",
        "15:59",
        "16:59",
        "17:59",
        "18:59",
        "19:59",
        "20:59",
        "21:59",
        "22:59",
        "23:59",
      ],
      searchroomlist: [],
      roomlist: [],
      bookingDate: this.$dayjs(new Date()).format("YYYY-MM-DD"),
      bookingStime: this.$dayjs(new Date()).format("HH:00"),
      bookingEtime: this.$dayjs(new Date()).format("HH:59"),
      modalObj: {
        bookingno: null,
        roomno: 1,
        starttime: null,
        endtime: null,
        memo: null,
      },
      view_hide: null,
    };
  },
  watch: {
    searchData: {
      handler: function (val, oldVal) {
        this.init();
      },
      deep: true,
    },
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.bookingList(this.searchData, (data) => {
        // alert(this.searchData);
        if (data) {
          this.bookinglist = data.bookinglist;
          this.data_yn = true;
        } else {
          this.bookinglist = [];
          this.data_yn = false;
        }
        this.get_roomlist();
      });
    },
    searchDateChange() {
      this.init();
    },
    get_roomlist() {
      ax.get_roomlist((data) => {
        // console.log(data);
        // alert(data.roomlistcnt);
        if (data) {
          this.roomlist = [];
          this.searchroomlist = [];
          this.roomlist = data.roomlist;
          this.searchroomlist = data.roomlist;
        } else {
          alert(data);
        }
      });
    },
    modalOpen(o) {
      if (o && !this.isEmpty(o)) {
        this.modalObj = o;
        this.bookingDate = this.$dayjs(o.timezone_starttime).format(
          "YYYY-MM-DD"
        );
        this.bookingStime = this.$dayjs(o.timezone_starttime).format("HH:00");
        this.bookingEtime = this.$dayjs(o.timezone_endtime).format("HH:59");

        // if (this.bookingEtime == "00:00") this.bookingEtime = "24:00";
      } else {
        if (this.searchData.searchdate) {
          this.bookingDate = this.searchData.searchdate;
        } else {
          this.bookingDate = this.$dayjs(new Date()).format("YYYY-MM-DD");
        }
      }
      this.$refs["modal-booking-list"].modalOuterStyle.zIndex = 9999;
      this.$refs["modal-booking-list"].show();
    },
    bookingDateChange(v) {
      this.bookingDate = v;
    },
    bookingRev() {
      if (this.searchData.searchdate) {
        this.bookingDate = this.searchData.searchdate;
      } else {
        this.bookingDate = this.$dayjs(new Date()).format("YYYY-MM-DD");
      }
      this.bookingStime = this.$dayjs(new Date()).format("HH:00");
      this.bookingEtime = this.$dayjs(new Date())
        .add(1, "hour")
        .format("HH:59");
      this.modalObj.roomno = 1;
      this.modalObj.bookingno = null;
      this.modalObj.starttime =
        this.bookingDate + " " + this.bookingStime + ":00";
      this.modalObj.endtime =
        this.bookingDate + " " + this.bookingEtime + ":59";
      this.modalObj.memo = null;
      this.$refs["modal-booking-list"].modalOuterStyle.zIndex = 9999;
      this.$refs["modal-booking-list"].show();
    },
    bookinSave() {
      this.modalObj.starttime =
        this.bookingDate + " " + this.bookingStime + ":00";
      this.modalObj.endtime =
        this.bookingDate + " " + this.bookingEtime + ":59";
      if (this.modalObj.bookingno) {
        ax.bookingModify(this.modalObj, (flag, data) => {
          if (flag) {
            this.$notify({
              group: "info",
              type: "warn",
              title: "Notice",
              text: this.$i18n.t("text.booking.booking_has_been_modified"),
            });
          }
          this.init();
          this.$refs["modal-booking-list"].hide();
        });
      } else {
        delete this.modalObj["bookingno"];
        ax.bookingInsert(this.modalObj, (flag, data) => {
          if (flag) {
            this.$notify({
              group: "info",
              type: "warn",
              title: "Notice",
              text: this.$i18n.t("text.booking.successfully_booked"),
            });
          }
          this.init();
          this.$refs["modal-booking-list"].hide();
        });
      }
    },
    bookinDelete() {
      ax.bookingDelete(this.modalObj.bookingno, (flag, data) => {
        if (flag) {
          this.$notify({
            group: "info",
            type: "warn",
            title: "Notice",
            text: this.$i18n.t("text.booking.successfully_booked"),
          });
        }
        this.init();
        this.$refs["modal-booking-list"].hide();
      });
    },
    toggle_tr(idx) {
      if (this.view_hide === idx) this.view_hide = null;
      else this.view_hide = idx;
    },
  },
};
</script>
